import { FacetFields } from '@yme/utils/bloomreach';
export const filterLabelKeyMap = {
    [FacetFields.SUBCATEGORIES]: 'productsGrid_subcategoriesFilter_label',
    [FacetFields.COLLECTION]: 'productsGrid_collectionFilter_label',
    [FacetFields.GENDER]: 'productsGrid_genderFilter_label',
    [FacetFields.TYPE]: 'productsGrid_typeFilter_label',
    [FacetFields.SIZES]: 'productsGrid_sizeFilter_label',
    [FacetFields.COLORS]: 'productsGrid_colourFilter_label',
    [FacetFields.UNIT_TYPE]: 'productsGrid_modelTypeFilter_label',
};
export const COUNT_FILTERS_ROW = 3;
